<template>
  <div class="container">
    <div class="row">
      <div class="overviewAndNav mb-1">
        <h3>Overzicht gebruikers</h3>
        <span>
          <select class="form-select" v-model="userFiltering">
            <option :key="mode" v-for="mode in getFilterModes()">{{ mode }}</option>
          </select>
          <button v-if="!showCreateUser" class="btn-basic btn-fill-pulse" @click="toggleCreateUser">Nieuw</button>
          <button v-if="showCreateUser" class="btn-basic btn-fill-pulse-dark" @click="toggleCreateUser">Annuleren</button>
        </span>
      </div>
    </div>
    <div class="row my-2">
      <input
          ref="focusMe"
          type="text"
          class="form-control"
          placeholder="Zoeken op voornaam .."
          v-model="search"/>
    </div>
    <div class="row" v-show="showCreateUser">
      <CreateUserComponent id="createUser" @userAdded="userAdded"/>
    </div>
    <div class="row">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead class="thead-dark">
          <tr>
            <SortableTableHeaderComponent
                columnName="id" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Gebruiker id"/>
            <SortableTableHeaderComponent
                columnName="email" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Email"/>
            <SortableTableHeaderComponent
                columnName="firstName" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Voornaam"/>
            <SortableTableHeaderComponent
                columnName="lastName" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Achternaam"/>
            <SortableTableHeaderComponent
                columnName="partTimePercentage" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Deeltijds percentage"/>
            <SortableTableHeaderComponent
                columnName="recup" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Recup"/>
            <SortableTableHeaderComponent
                columnName="active" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Status"/>
            <th scope="col">Actie</th>
          </tr>
          </thead>
          <template v-for="user in sortedUsers">
            <tr :key="user.id">
              <td>{{ user.id }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.firstName }}</td>
              <td>{{ user.lastName }}</td>
              <td>{{ user.partTimePercentage }}</td>
              <td>{{ user.recup | convertDotToCommaInNumber }}</td>
              <td>{{ getStatusText(user.employmentEndDate) }}</td>
              <td>
                <button class="btn-basic btn-outline-pulse" @click="showDetailed(user)">Meer details</button>
              </td>
            </tr>
          </template>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import CreateUserComponent from "@/Admin/CreateUserComponent/CreateUserComponent";
import FilterModes, {ActivityStatusList} from "@/constants/FilterConstants";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";

export default {
  name: "AdminUserComponent",
  components: {
    SortableTableHeaderComponent,
    CreateUserComponent,
  },
  data: () => ({
    showCreateUser: false,
    userFiltering: FilterModes.ACTIVE,
    currentSortColumn: "id",
    currentSortDirectionAscending: true,
    search: '',
  }),
  computed: {
    ...mapGetters({
      users: "administrationUser/users"
    }),
    sortedUsers: function () {
      let sortedList;
      if (this.currentSortColumn === "active") {
        sortedList = sortListByColumnAndDirection(this.filterUsers(), this.currentSortColumn, this.currentSortDirectionAscending, this.getStatusText);
      }
      sortedList = sortListByColumnAndDirection(this.filterUsers(), this.currentSortColumn, this.currentSortDirectionAscending);
      return sortedList.filter(user => {
        return user.firstName.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  mounted() {
    this.$refs.focusMe.focus();
  },
  async created() {
    await this.fetchUsers();
  },
  methods: {
    ...mapActions("administrationUser", [
        "fetchUsers",
        "fetchHREmployers"
    ]),
    ...mapMutations({
      setSelectedUser: "administrationUser/setSelectedUser"
    }),
    showDetailed: function (user) {
      this.setSelectedUser(user);
      this.$router.push({path: "/admin/viewUserDetail"});
    },
    toggleCreateUser() {
      this.showCreateUser = !this.showCreateUser;
      if (this.showCreateUser) {
        this.fetchHREmployers();
      }
    },
    userAdded() {
      this.toggleCreateUser();
      this.fetchUsers();
    },
    getFilterModes() {
      return ActivityStatusList;
    },
    getStatusText(employmentEndDate) {
      return employmentEndDate === null ? FilterModes.ACTIVE : FilterModes.NOT_ACTIVE;
    },
    filterUsers() {
      if (this.userFiltering === FilterModes.ACTIVE) {
        return this.users.filter(user => !user.employmentEndDate);
      }
      if (this.userFiltering === FilterModes.NOT_ACTIVE) {
        return this.users.filter(user => user.employmentEndDate);
      }
      return this.users;
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    }
  },
};
</script>

<style scoped>
tbody tr {
  cursor: pointer;
}

tbody tr:hover {
  background-color: aliceblue;
}

td {
  vertical-align: middle;
}

.overviewAndNav {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>